<div class="attempts-allowed-container">
  <div class="content">
    <div class="box-container">
      <div class="box">
        <img src="assets/images/warning.png" class="monex">
        {{"Superaste el numero de intentos permitidos"|translate}}
      </div>
    </div>
    <div class="paragraph">
      <p>
        {{"Por seguridad"|translate}},  <span class="blue-label">{{"deshabilitamos tus accesos"|translate}}.</span>
      </p>
    </div>
    <div class="paragraph">
      <p>
        {{"Para recuperar tus accesos"|translate}}
        <span class="blue-label">gac@monex.com.mx</span> {{"con los siguientes datos"|translate}}:
      </p>
    </div>
    <div class="paragraph">
      <p>{{"Asunto"|translate}}: {{"Desbloqueo de usuario y contrasena"|translate}}</p>
      <ul>
        <li>{{"Numero de contrato"| translate}}</li>
      <li>{{"Nombre completo del Titular del contrato"| translate}}</li>
      <li>{{"Nombre completo del Participante del contrato"| translate}}</li>
      </ul>
      <div>{{"utiliza el mismo correo que autorizaste en el sistema"| translate}}</div>
    </div>
    <div class="btn-container">
      <button
        class="btn btn-primary"
        (click)="redirect()"
      >{{'Ir a Banca digital'|translate}}</button>
    </div>
  </div>
</div>
